class manageReqsCtrl {
  /* @ngInject */
  constructor ($mdDialog, $mdToast, ManageJobs, reqs, jobId) {
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.mj = ManageJobs
    this.jobId = jobId
    this.reqs = reqs
    this.req0 = reqs[0]
    this.req1 = reqs[1]
    this.req2 = reqs[2]

    this.changed = false
  }

  confirm () {
    let confirmation
    if (this.changed) {
      confirmation = this.$mdDialog.confirm({
        title: 'Modify Requirments',
        ok: 'Ok',
        cancel: 'Cancel'
      })

      return this.$mdDialog.show(confirmation)
        .then(() => {
          return this.mj.updateReqs({
            jobId: this.jobId,
            requirements: [
              this.req0,
              this.req1,
              this.req2
            ]
          })
        })
        .then(() => this.$mdToast.showSimple('Requirements successfully updated.'))
        .catch(() => this.$mdToast.showSimple('Unable to update requirements.'))
        .finally(() => {
          confirmation = undefined
        })
    }
    this.$mdDialog.hide()
  }

  close () {
    return this.$mdDialog.hide()
  }
}

export default manageReqsCtrl
